import { authService, performerService, userService } from '@services/index';
import { message } from 'antd';
import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import {
  setUpdating,
  updateUserSuccess,
  updateUserFail,
  updatePasswordSuccess,
  updatePasswordFail
} from './userSlice';

function* updateUserSaga(action: PayloadAction<any>) {
  try {
    yield put(setUpdating(true));
    const updated = yield call([userService, 'updateMe'], action.payload);
    yield put(updateUserSuccess(updated.data));
    message.success('Changes saved');
  } catch (e) {
    const error = yield Promise.resolve(e);
    yield put(updateUserFail(error));
    message.error(error?.message || 'An error occurred updating user');
  } finally {
    yield put(setUpdating(false));
  }
}

function* updatePerformerSaga(action: PayloadAction<any>) {
  try {
    yield put(setUpdating(true));
    const updated = yield call([performerService, 'updateMe'], action.payload);
    yield put(updateUserSuccess(updated.data));
    message.success('Changes saved');
  } catch (e) {
    const error = yield Promise.resolve(e);
    yield put(updateUserFail(error));
    message.error(error?.message || 'An error occurred updating performer');
  } finally {
    yield put(setUpdating(false));
  }
}

function* updatePasswordSaga(action: PayloadAction<{ password: string; oldPassword: string }>) {
  try {
    yield put(setUpdating(true));
    const updated = yield call([authService, 'updatePassword'], action.payload.password);
    yield put(updatePasswordSuccess(updated.data));
    message.success('Password updated successfully');
  } catch (e) {
    const error = yield Promise.resolve(e);
    yield put(updatePasswordFail(error));
    message.error(error?.message || 'An error occurred updating password');
  } finally {
    yield put(setUpdating(false));
  }
}

export default function* userSaga() {
  yield takeLatest('user/updateUser', updateUserSaga);
  yield takeLatest('user/updatePerformer', updatePerformerSaga);
  yield takeLatest('user/UPDATE_PASSWORD', updatePasswordSaga);
}